export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-information-line text-sm"></i>
            关于平台
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-6">
            关于我们
          </h2>

          <div className="text-sm md:text-base text-foreground-500 leading-relaxed space-y-4">
            <p>
              6080影院成立于2020年，是一家专注于高清在线影院体验的免费影视大全平台。
              我们致力于为全球华语观众提供高清电影免费看和免费电视剧全集资源，
              让每一位用户都能享受到不缓冲、不卡顿的高清视频播放体验。
            </p>
            <p>
              平台汇聚超过20000部影视资源，涵盖动作、喜剧、科幻、悬疑、爱情、恐怖、动画等全类型内容。
              从最新院线大片到经典老片，从国产剧到海外热剧，6080影院始终坚持"高清、免费、流畅"三大核心原则，
              用技术与诚意打造最好的免费在线观看平台。
            </p>
            <p>
              未来，我们将持续优化播放技术、扩充内容库，为更多影迷带来极致的高清在线影院体验。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
            {[
              { num: '20000+', label: '影视资源' },
              { num: '500万+', label: '月活用户' },
              { num: '99.9%', label: '播放成功率' },
              { num: '4年', label: '稳定运营' },
            ].map((stat) => (
              <div key={stat.label} className="p-4 rounded-xl bg-background-100 border border-background-200/60">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading mb-1">
                  {stat.num}
                </div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}